import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';

const ReliabilityCalculatorContext = createContext();

const initialState = {
  step1: '',
  step2: 1000,
  step3: 5,
  step4: 99.999,
  step5: 'yes',
  step6: 'yes',
  step7: 'yes-business',
  step8: 'yes-monitoring',
  step9: 'never',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'choice':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const ReliabilityCalculatorProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };

  return (
    <ReliabilityCalculatorContext.Provider value={value}>
      {children}
    </ReliabilityCalculatorContext.Provider>
  );
};

ReliabilityCalculatorProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { ReliabilityCalculatorContext, ReliabilityCalculatorProvider };
